import React from "react";
import classes from "./Modal.module.scss";
import CloseIcon from "@mui/icons-material/Close";

interface ModalProps {
    title: string;
    isVisible: boolean;
    onClose: () => void;
    children: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({ title, isVisible, onClose, children }) => {
    if (!isVisible) return null; // Don't render the modal if it's not visible

    return (
        <div className={classes.modalOverlay} onClick={onClose}>
            <div
                className={classes.modalContent}
                onClick={(e) => e.stopPropagation()} // Prevent closing the modal when clicking inside
            >
                <header className={classes.modalHeader}>
                    <CloseIcon onClick={onClose} />
                    <h2>{title}</h2>
                </header>
                <p> * indicates required</p>
                <div className={classes.modalBody}>{children}</div>
            </div>
        </div>
    );
};

export default Modal;
